import React from 'react'
import SEO from '../../../utils/CommonFunctionality/SEO'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import Layout from '../Layout'

export default function aboutus(props) {
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'

    return (
        <>
            {isPrimeBids ? (
                <SEOTAG page="About Us" />
            ) : (
                <SEO title={`${global?.storeDetails?.name} | About Us`} />
            )}
            <Layout props={props}>
                <div className="px-md-5 px-3 py-4 staticPgWrapper">
                    {/* <h2>About Us</h2> */}
                    <span
                        dangerouslySetInnerHTML={{
                            __html: global.storeDetails.privacy,
                        }}
                    ></span>
                </div>
            </Layout>
        </>
    )
}
